// extracted by mini-css-extract-plugin
export default {"wrapper":"Tp-z","response":"Up-z","error":"Vp-z","disabled":"Wp-z","buttons":"Xp-z","feedbackQuestionSection":"Yp-z","yesNoWrapper":"Zp-z"};